module.exports = __webpack_public_path__ + "static/media/windows_down_m.1a9270e7.png";